
export const sitekeyRecaptcha = "6LdDE8EZAAAAAGeEYRoiATfkcFsvONhXpwu-Jxy6";
export const isDev = process.env.REACT_APP_ISDEV || false;
// export const GA_TRACKING_CODE = 'G-2RFLKBK0L3'
export const GA_TRACKING_CODE_UA =  process.env.REACT_APP_GA_TRACKING_CODE_UA||'UA-231700064-1'
export const URL_CLAVE_UNICA=process.env.REACT_APP_BASE_URL_CLAVE_UNICA || 'https://desa-auth.superdesalud.gob.cl/'
export const baseUrlClaveUnice = process.env.REACT_APP_BASE_URL_CLAVE_UNICA || "https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout";
 
export const siteUrl= process.env.REACT_APP_SITE_URL_2 || "localhost:3000"
export const ORIGEN= process.env.REACT_APP_SITE_ORIGEN || "desa-tramites"
export const TIPO_USR='?type=c'
//export const ORIGEN="localhost"
